module.exports = __webpack_public_path__ + "static/media/mail.138c4eaf.svg";